__turbopack_context__.v({
  "addItemButton": "_1BGS2G_addItemButton",
  "bottomBar": "_1BGS2G_bottomBar",
  "bottomBarNoInstallments": "_1BGS2G_bottomBarNoInstallments",
  "container": "_1BGS2G_container",
  "headerContainer": "_1BGS2G_headerContainer",
  "immutable": "_1BGS2G_immutable",
  "labelContainer": "_1BGS2G_labelContainer",
  "mobileHeader": "_1BGS2G_mobileHeader",
});
